﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyDriveawayPrice", [
    "DebugLogger",
    function (DebugLogger) {
      function rejectHandler(error) {
        DebugLogger.log("tyDriveawayPrice", error);
      }

      var controller = [
        "$scope",
        "$element",
        "$filter",
        "$q",
        "API",
        "Location",
        "Range",
        "Dealer",
        "DealerSelector",
        "$timeout",
        "Animations",
        function ($scope, $element, $filter, $q, API, Location, Range, Dealer, DealerSelector, $timeout, Animations) {
          var ctl = this;
          var lastFetchPriceInProgress = null;
          var lastGetDriveawayPriceResponse = null;
          var currentRegion = null;
          var $wasPriceContainer = $element.find("[data-ty-driveaway-price-was-price-container]");

          $scope.driveawayPrice = $scope.driveawayPrice || {};
          $scope.financingOptions = $scope.financingOptions || {};

          function setLoading(value) {
            $scope.$evalAsync(function () {
              $scope.driveawayPrice.loading = value;
            });
          }

          function emitDidRequestToLoadReject(errorProps) {
            DebugLogger.log("tyDriveawayPrice", "emitDidRequestToLoadReject", errorProps);
            setLoading(false);
            resetNextRepaintErrors();

            if (errorProps) {
              angular.extend($scope.driveawayPrice.nextRepaintErrors, errorProps);
            }
          }

          function emitDidLoadingBegin() {
            DebugLogger.log(
              "tyDriveawayPrice",
              "emitDidLoadingBegin for material code",
              $scope.driveawayPrice.materialCode,
              "/ usageType",
              $scope.driveawayPrice.usageType
            );
            setLoading(true);
            resetNextRepaintErrors();
          }

          function emitDidLoadingEnd(errorProps) {
            if (errorProps) {
              DebugLogger.log("tyDriveawayPrice", "emitDidLoadingEnd", errorProps);
            } else {
              DebugLogger.log("tyDriveawayPrice", "emitDidLoadingEnd");
            }

            setLoading(false);
            resetNextRepaintErrors();

            if (errorProps) {
              angular.extend($scope.driveawayPrice.nextRepaintErrors, errorProps);
            }
          }

          function emitDidLoadingEndSuccess() {
            DebugLogger.log("tyDriveawayPrice", "emitDidLoadingEndSuccess");
            emitDidLoadingEnd();
          }

          function init() {
            ctl.manualReload = $element.attr("data-ty-driveaway-price-manual-reload") === "true";
            ctl.manualRepaint = $element.attr("data-ty-driveaway-price-manual-repaint") === "true";

            if ($element.attr("data-ty-driveaway-price-initial-material-code")) {
              $scope.driveawayPrice.materialCode = $element.attr("data-ty-driveaway-price-initial-material-code");
            }

            if ($element.attr("data-ty-driveaway-price-usage-type-available")) {
              $scope.driveawayPrice.usageTypeAvailable =
                $element.attr("data-ty-driveaway-price-usage-type-available") === "true";
            }

            if ($element.attr("data-ty-driveaway-price-initial-usage-type")) {
              $scope.driveawayPrice.usageType = $element.attr("data-ty-driveaway-price-initial-usage-type");
            }

            if ($element.attr("data-ty-driveaway-price-requires-special-offers")) {
              $scope.driveawayPrice.requiresSpecialOffers =
                $element.attr("data-ty-driveaway-price-requires-special-offers") === "true";
            }

            $scope.driveawayPrice.hasHadAllDataAtLeastOnce = false;

            resetDriveawayPrice();
            resetFinancingOptions();
            Animations.hide($wasPriceContainer);

            $scope.specialOffer = $scope.specialOffer || {};
            resetSpecialOffer();

            // Handle Price Change on Location change or First time Auto GeoDecode
            $scope.$on("GeoPostCode", function () {
              fetchLocation();

              if (!ctl.manualReload) {
                DebugLogger.log(
                  "tyDriveawayPrice",
                  "GeoPostCode change about to trigger driveawayPrice.fetchPriceThenRepaint"
                );
                $scope.driveawayPrice.fetchPriceAndRepaint();
              }
            });

            var isFirstWatchForDriveawayPrice = true;
            // if changing material code, update prices
            $scope.$watchGroup(["driveawayPrice.materialCode", "driveawayPrice.usageType"], function () {
              if (isFirstWatchForDriveawayPrice) {
                isFirstWatchForDriveawayPrice = false;
                return;
              }

              if (!ctl.manualReload) {
                DebugLogger.log(
                  "tyDriveawayPrice",
                  "materialCode / usageType change about to trigger driveawayPrice.fetchPriceThenRepaint"
                );
                $scope.driveawayPrice.fetchPriceAndRepaint();
              }
            });

            var isFirstWatchForSimulatedMissingData = true;
            // if there is a data error saying to hide the price
            $scope.$watch("driveawayPrice.simulateMissingData", function (simulateMissingData) {
              if (isFirstWatchForSimulatedMissingData) {
                isFirstWatchForSimulatedMissingData = false;
                return;
              }

              DebugLogger.log(
                "tyDriveawayPrice",
                "simulateMissingData change about to trigger driveawayPrice.fetchPriceThenRepaint"
              );

              if (simulateMissingData) {
                $scope.driveawayPrice.hasHadAllDataAtLeastOnce = true;
              }

              if (!ctl.manualReload) {
                $scope.driveawayPrice.fetchPriceAndRepaint();
              }
            });

            fetchLocation();

            if (!ctl.manualReload) {
              DebugLogger.log("tyDriveawayPrice", "init about to trigger driveawayPrice.fetchPriceThenRepaint");
              $scope.driveawayPrice.fetchPriceAndRepaint();
            }
          }

          function cancelFetchPrice() {
            if (!lastFetchPriceInProgress) {
              throw new Error("cancelFetchPrice: no lastFetchDriveawayPriceRequestInProgress to cancel");
            }

            API.cancel(lastFetchPriceInProgress);
            var lastFetchPriceRequestCancelled = lastFetchPriceInProgress;
            lastFetchPriceInProgress = null;
            return lastFetchPriceRequestCancelled;
          }

          $scope.driveawayPrice.fetchPriceAndRepaint = function () {
            return $scope.driveawayPrice
              .fetchPrice()
              .catch(rejectHandler)
              .finally(function () {
                if (!ctl.manualRepaint) {
                  $scope.driveawayPrice.repaint();
                }
              });
          };

          $scope.driveawayPrice.fetchPrice = function () {
            // check to see if we should be hiding price
            if (!hasAllData()) {
              /*
               * When initialising, we are missing a material code but
               * we don't want to show an error
               */
              if ($scope.driveawayPrice.hasHadAllDataAtLeastOnce) {
                emitDidRequestToLoadReject({ dataError: true });
              } else {
                emitDidRequestToLoadReject();
              }

              return $q.reject("Can't fetchPrice() - this request requires materialCode, and usageType (if available)");
            }

            $scope.driveawayPrice.hasHadAllDataAtLeastOnce = true;

            if (!haveLocationData()) {
              $scope.driveawayPrice.locationError = true;
              emitDidRequestToLoadReject({ locationError: true });
              return $q.reject("Can't fetchPrice() - location data required");
            }

            if (lastFetchPriceInProgress) {
              return cancelFetchPrice().finally(continueFetchingPrice);
            }

            return continueFetchingPrice();

            function continueFetchingPrice() {
              emitDidLoadingBegin();

              lastFetchPriceInProgress = fetchDriveawayPrice(
                $scope.driveawayPrice.materialCode,
                $scope.driveawayPrice.postcode,
                $scope.driveawayPrice.usageType
              )
                .catch(function () {
                  emitDidLoadingEnd({ serverError: true });
                  return $q.reject(
                    "fetchPrice() could not continue fetching price due to a failure in fetchDriveawayPrice()"
                  );
                })
                .finally(function () {
                  lastFetchPriceInProgress = null;
                });
              return lastFetchPriceInProgress;
            }
          };

          function resetNextRepaintErrors() {
            $scope.driveawayPrice.nextRepaintErrors = {};
            $scope.driveawayPrice.nextRepaintErrors.serverError = false;
            $scope.driveawayPrice.nextRepaintErrors.dataError = false;
            $scope.driveawayPrice.nextRepaintErrors.dataErrorType = null;
            $scope.driveawayPrice.nextRepaintErrors.locationError = false;
          }

          function resetDriveawayPrice() {
            setLoading(true);
            resetNextRepaintErrors();

            $scope.driveawayPrice.price = 0;
            $scope.driveawayPrice.disclaimerOverride = "";
            $scope.driveawayPrice.simulateMissingData = false;
            $scope.driveawayPrice.financeInfoAvailable = true;
            $scope.driveawayPrice.isPriceOverridden = false;
            $scope.driveawayPrice.isPriceOverrideActive = false;
            $scope.driveawayPrice.isBasePriceMatchSpecialOffer = false;
            $scope.driveawayPrice.disclaimerAdjustment = "";
          }

          function repaintErrors() {
            $scope.driveawayPrice.serverError = $scope.driveawayPrice.nextRepaintErrors.serverError;
            $scope.driveawayPrice.dataError = $scope.driveawayPrice.nextRepaintErrors.dataError;
            $scope.driveawayPrice.dataErrorType = $scope.driveawayPrice.nextRepaintErrors.dataErrorType;
            $scope.driveawayPrice.locationError = $scope.driveawayPrice.nextRepaintErrors.locationError;
          }

          $scope.driveawayPrice.repaint = function () {
            repaintErrors();

            var response = lastGetDriveawayPriceResponse;

            // the rest of repaint only handles response output, not errors
            if (!response) {
              return;
            }

            var pricingOptions = response.pricingOptions;
            var specialOffers = response.specialOffers;

            $scope.driveawayPrice.price = window.parseFloat(pricingOptions.Driveaway_Price);

            $scope.driveawayPrice.isPriceOverridden = pricingOptions.Is_Driveaway_Price_Overridden;
            $scope.driveawayPrice.isPriceOverrideActive = pricingOptions.Is_Active;
            $scope.driveawayPrice.disclaimerOverride = pricingOptions.Is_Driveaway_Price_Overridden
              ? pricingOptions.Driveaway_Price_Disclaimer
              : "";
            $scope.driveawayPrice.disclaimerAdjustment = pricingOptions.Price_Adjustment_Disclaimer
              ? pricingOptions.Price_Adjustment_Disclaimer
              : "";
            $scope.applyFinanceOptions(pricingOptions.Finance_Options);
            $scope.applySpecialOffers(specialOffers);

            if ($scope.driveawayPrice.wasPrice !== null) {
              $scope.driveawayPrice.wasPriceDisplay = $scope.driveawayPrice.wasPrice;
              $timeout(function () {
                Animations.slideThenFadeIn($wasPriceContainer);
              });
            } else {
              Animations.fadeThenSlideOut($wasPriceContainer);
            }
          };

          function fetchDriveawayPrice(materialCode, postcode, usageType) {
            var rangePricingCall;

            /*
             * Choose which API to run the driveaway price request through,
             * depending on what data we have available and what we want to
             * see coming out the other end.
             */

            if ($scope.driveawayPrice.requiresSpecialOffers || !$scope.driveawayPrice.usageTypeAvailable) {
              rangePricingCall = Range.getPricingOptionsAndSpecialOffersByMaterialCode(materialCode, {
                postcode: postcode,
                usageType: usageType,
              });
            } else {
              rangePricingCall = Range.getPricingOptionsByMaterialCode(materialCode, {
                postcode: postcode,
                usageType: usageType,
              });
            }

            return rangePricingCall
              .then(function (response) {
                if (!response.pricingOptions) {
                  emitDidRequestToLoadReject({ dataError: true });
                  return $q.reject("fetchDriveawayPrice - range pricing response is missing pricingOptions");
                }

                var pricingOptions = response.pricingOptions;

                if (isNaN(parseFloat(pricingOptions.Driveaway_Price))) {
                  emitDidLoadingEnd({ dataError: true });
                  return undefined;
                }

                emitDidLoadingEndSuccess();

                DebugLogger.log(
                  "tyDriveawayPrice",
                  "fetchDriveawayPrice stored response for",
                  materialCode,
                  postcode,
                  response
                );

                lastGetDriveawayPriceResponse = response;
                $scope.driveawayPrice.hasPrice = !!response.pricingOptions.Driveaway_Price;

                return undefined;
              })
              .catch(function () {
                emitDidRequestToLoadReject({ dataError: true });
                return $q.reject("fetchDriveawayPrice range pricing call failed");
              });
          }

          function fetchLocation() {
            var location = DealerSelector.getDealerLocationFallbackToGeolocation();
            $scope.driveawayPrice.postcode = location.postcode;
            $scope.driveawayPrice.suburb = location.suburb;
            $scope.driveawayPrice.state = location.state;
            $scope.driveawayPrice.region = location.region;
            $scope.driveawayPrice.locationString = location.locationString;
            $scope.driveawayPrice.locationStringLine1 = location.dealerName;
            $scope.driveawayPrice.locationStringLine2 = location.dealerName
              ? location.alternativeLocationString
              : location.locationString;

            currentRegion = location.region;
          }

          function hasAllData() {
            // have material code
            if (
              !$scope.driveawayPrice.materialCode ||
              ($scope.driveawayPrice.usageTypeAvailable && !$scope.driveawayPrice.usageType)
            ) {
              return false;
            }

            // parent scope data error override
            return !$scope.driveawayPrice.simulateMissingData;
          }

          function haveLocationData() {
            fetchLocation();
            return !!$scope.driveawayPrice.postcode;
          }

          function resetFinancingOptions() {
            $scope.financingOptions.priceWeek = "";
            $scope.financingOptions.priceWeekText = "";
            $scope.financingOptions.compRate = "";
            $scope.financingOptions.compRateText = "";
            $scope.financingOptions.loanTerm = "";
            $scope.financingOptions.loanTermText = "";
            $scope.financingOptions.leftText = "";
            $scope.financingOptions.leftLink = "";
            $scope.financingOptions.midText = "";
            $scope.financingOptions.midLink = "";
            $scope.financingOptions.rightText = "";
            $scope.financingOptions.rightLink = "";
          }

          $scope.applyFinanceOptions = function (financeOptions) {
            resetFinancingOptions();

            if (financeOptions) {
              // Don't provide any financingOptions unless all of priceWeek, compRate and loanTerm are present
              if (
                !$scope.driveawayPrice.isPriceOverrideActive ||
                !financeOptions.Left_Text_1 ||
                !financeOptions.Mid_Text_1 ||
                !financeOptions.Right_Text_1 ||
                !financeOptions.Left_Text ||
                !financeOptions.Mid_Text ||
                !financeOptions.Right_Text
              ) {
                return;
              }

              if ($scope.driveawayPrice.isPriceOverrideActive) {
                $scope.financingOptions.priceWeek = financeOptions.Left_Text_1;
                $scope.financingOptions.priceWeekText = financeOptions.Left_Text_2;
                $scope.financingOptions.compRate = financeOptions.Mid_Text_1;
                $scope.financingOptions.compRateText = financeOptions.Mid_Text_2;
                $scope.financingOptions.loanTerm = financeOptions.Right_Text_1;
                $scope.financingOptions.loanTermText = financeOptions.Right_Text_2;
                $scope.financingOptions.leftText = financeOptions.Left_Text;
                $scope.financingOptions.leftLink = financeOptions.Left_Text_Link;
                $scope.financingOptions.midText = financeOptions.Mid_Text;
                $scope.financingOptions.midLink = financeOptions.Mid_Text_Link;
                $scope.financingOptions.rightText = financeOptions.Right_Text;
                $scope.financingOptions.rightLink = financeOptions.Right_Text_Link;
              }
            }
          };

          function resetSpecialOffer() {
            $scope.driveawayPrice.wasPrice = null;
            $scope.driveawayPrice.isHot = false;
            $scope.driveawayPrice.isCool = false;
            $scope.driveawayPrice.endDate = null;
            $scope.specialOffer.isVisible = null;
            $scope.specialOffer.isHot = false;
            $scope.specialOffer.isCool = false;
            $scope.specialOffer.description = null;
            $scope.specialOffer.isDescription = false;
            $scope.specialOffer.bannerTitle = null;
          }

          $scope.applySpecialOffers = function (specialOffers) {
            resetSpecialOffer();

            if (specialOffers && specialOffers.length) {
              var validSpecialOffers = specialOffers.filter(function (specialOffer) {
                return (
                  (specialOffer.Region.indexOf("ALL REGIONS") >= 0 ||
                    specialOffer.Region.toString().indexOf(currentRegion) >= 0) &&
                  specialOffer.IsVisibleOnPricingPage
                );
              });

              if (validSpecialOffers.length) {
                var specialOffer = validSpecialOffers[0];
                var isHot = specialOffer.IsHot;

                if (
                  !specialOffer.IsNonPriceOffer &&
                  specialOffer.ShouldOverrideOfferPrice &&
                  specialOffer.TotalPrice &&
                  specialOffer.TotalPrice !== "0"
                ) {
                  $scope.driveawayPrice.wasPrice = $scope.driveawayPrice.price;
                  $scope.driveawayPrice.price = window.parseFloat(specialOffer.TotalPrice);
                  $scope.driveawayPrice.disclaimerOverride = specialOffer.Content.PriceDisclaimerText;
                  $scope.driveawayPrice.isHot = isHot;
                  $scope.driveawayPrice.isCool = !isHot;
                  $scope.driveawayPrice.endDate = "Offer ends " + $filter("date")(specialOffer.OfferEndDate, "MMM d");

                  if ($scope.driveawayPrice.price > $scope.driveawayPrice.wasPrice) {
                    emitDidLoadingEnd({ dataError: true, dataErrorType: "INVALID_WAS_PRICE" });

                    if (!ctl.manualRepaint) {
                      $scope.driveawayPrice.repaintErrors();
                    }

                    return;
                  }

                  if ($scope.driveawayPrice.price === specialOffer.TotalPrice) {
                    $scope.driveawayPrice.isBasePriceMatchSpecialOffer = true;
                  }
                }

                $scope.driveawayPrice.endDate = "Offer ends " + $filter("date")(specialOffer.OfferEndDate, "MMM d");

                $scope.specialOffer.isVisible = true;
                $scope.specialOffer.isHot = isHot;
                $scope.specialOffer.isCool = !isHot;
                $scope.specialOffer.description =
                  specialOffer.Content.OfferDescription !== null ? specialOffer.Content.OfferDescription.trim() : "";
                $scope.specialOffer.isDescription = $scope.specialOffer.description !== "";
                $scope.specialOffer.bannerTitle = specialOffer.Content.BannerTitle;
              }
            }
          };

          $scope.driveawayPrice.shouldShowPrice = function () {
            if (
              $scope.driveawayPrice.locationError ||
              $scope.driveawayPrice.serverError ||
              $scope.driveawayPrice.dataError ||
              $scope.driveawayPrice.hideDriveawayPrice
            ) {
              return false;
            }

            return !($scope.driveawayPrice.price === 0 || $scope.driveawayPrice.price === "0");
          };

          $scope.driveawayPrice.showError = function () {
            if (
              $scope.driveawayPrice.locationError ||
              $scope.driveawayPrice.loading ||
              $scope.driveawayPrice.hideDriveawayPrice
            ) {
              return false;
            }

            return !!($scope.driveawayPrice.dataError || $scope.driveawayPrice.serverError);
          };

          $scope.driveawayPrice.showLocationError = function () {
            if ($scope.driveawayPrice.loading || $scope.driveawayPrice.hideDriveawayPrice) {
              return false;
            }

            return !!$scope.driveawayPrice.locationError;
          };

          this.$onInit = init;
        },
      ];

      return {
        scope: false,
        restrict: "A",
        controller: controller,
        controllerAs: "tyDriveawayPriceController",
        bindToController: true,
      };
    },
  ]);
})(window.angular);
